import { FC } from "react";
import Layout from "@/components/layout";
import verificationImageNl from "@/assets/images/verification-nl.webp";
import verificationImageDe from "@/assets/images/verification-de.webp";
import verificationImageEn from "@/assets/images/verification-en.webp";
import styles from "./index.module.scss";
import { Button } from "@/components/button";
import { Routes } from "@/types/routes";
import { useTranslation } from "react-i18next";
import { StillThereModal } from "@/components/still-there-modal";
import { Navigate } from "react-router-dom";
import useModalsStore from "@/stores/modals";
import ProductNotFoundModal from "pages/main-page/product-not-found-modal";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { selectRequiredAge } from "@/store/cart/selectors";
import { denyAgeCheck } from "@/store/cart/thunk";
import useScanning from "@/hooks/useScanning";
import ErrorInfoModals from "@/components/error-info-modals";

const VerificationPage: FC = () => {
  useScanning();
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const { invalidEanCode, setInvalidEanCode } = useModalsStore();
  const requiredAge = useAppSelector(selectRequiredAge);

  const onDeny = () => {
    dispatch(denyAgeCheck());
  };

  const getImageUrl = () => {
    if (i18n.language === "de") return verificationImageDe;
    if (i18n.language === "en") return verificationImageEn;
    return verificationImageNl;
  };

  if (requiredAge === null) return <Navigate to={Routes.MAIN} />;

  return (
    <Layout childrenClassName={styles.contentBox}>
      <div className={styles.imageWrapper} data-cy="verification-page">
        <img src={getImageUrl()} alt="Verification" className={styles.image} />
      </div>
      <div className={styles.mainWrapper}>
        <h2 data-cy="verification-page-title">
          {t("verificationPage.title", { age: requiredAge })}
        </h2>

        <div className={styles.instructions}>
          <p>{t("verificationPage.verifiedID")}</p>

          <div className={styles.divider}>
            <div className={styles.line} />
            <p className={styles.or}>{t("verificationPage.or")}</p>
            <div className={styles.line} />
          </div>

          <p>{t("verificationPage.getCodeAtReception")}</p>
        </div>

        <Button
          text={t("ui.cancel")}
          size="x-small"
          className={styles.cancelButton}
          onClick={onDeny}
          data-cy="cancel-button"
        />
      </div>
      {invalidEanCode !== null && (
        <ProductNotFoundModal
          onClose={() => setInvalidEanCode(null)}
          invalidEanCode={invalidEanCode}
        />
      )}
      <ErrorInfoModals />
      <StillThereModal secondsBeforeModal={90} />
    </Layout>
  );
};

export default VerificationPage;
